// pages/Devices/deviceotamodal.jsx
import React from 'react';

const DeviceOTAModal = ({ isOpen, onClose, onConfirm, device, type, loading }) => {
  if (!isOpen) return null;

  const getTitle = () => {
    switch(type) {
      case 'sota': return 'Sampler OTA';
      case 'cota': return 'Control Board OTA';
      case 's3ota': return 'S3 OTA';
      default: return 'OTA Update';
    }
  };

  const getMessage = () => {
    switch(type) {
      case 'sota':
        return `Are You Sure? You Want Do Sampler OTA - ${device?.handsetId || device?.devId}`;
      case 'cota':
        return `Are You Sure? You Want Do Control Board OTA - ${device?.deviceId || device?.cbid}`;
      case 's3ota':
        return `Are You Sure? You Want Do S3 OTA - ${device?.deviceId || device?.cbid}`;
      default:
        return `You want to do OTA update for this device`;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="ota-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{getTitle()}</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="ota-modal-body">
          <p className="ota-device-name">{getMessage()}</p>
          <p className="ota-warning">This action cannot be undone!</p>
        </div>
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="confirm-ota-btn" onClick={onConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Yes, Proceed'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceOTAModal;